import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { loadPage, pageFor, extrasFor } from './pages/registry';
import { stripLocale } from './i18n/locale';
import { LEGACY_REDIRECTS } from './seo/site.mjs';

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

/* Production HTML is pre-rendered at build time (scripts/prerender.mjs),
   so the root already holds the page. Hydrate it instead of throwing it
   away and rendering again. The dev server and any non-prerendered
   page still start from an empty root and use a normal render.
   A hydration mismatch makes React re-render the page from scratch;
   it is logged so it can be found and fixed rather than hidden. */
/* Pages are separate bundles (src/pages/registry.js). The one for this
   URL is fetched first, so the first render already has it and
   hydration matches the pre-rendered HTML; an unknown URL gets the
   404 page. */
function pageForLocation() {
  let path = stripLocale(window.location.pathname).replace(/\/+$/, '') || '/';
  const legacy = LEGACY_REDIRECTS.find((r) => r.from === path);
  if (legacy) path = legacy.to;
  const found = pageFor(path) || { page: 'notFound' };
  return { ...found, extras: extrasFor(path) };
}

const wanted = pageForLocation();
Promise.all([wanted.page, ...wanted.extras].map((p) => loadPage(p)))
  .catch(() => { /* a failed chunk still renders the shell; App reloads it */ })
  .then(() => {
    if (container.hasChildNodes()) {
      ReactDOM.hydrateRoot(container, app, {
        onRecoverableError(error) {
          // eslint-disable-next-line no-console
          console.warn('[hydration] React recovered from a mismatch:', error?.message || error);
        },
      });
    } else {
      ReactDOM.createRoot(container).render(app);
    }
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
